import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://rrmxlifiscejralzghsb.supabase.co'
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InJybXhsaWZpc2NlanJhbHpnaHNiIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTI4MTc2MjcsImV4cCI6MjA2ODM5MzYyN30.zDQd_SyNaTqDlcYQ5TDzOpCUttgpBzIhteLjti_2mQE'

if (supabaseUrl === 'https://<PROJECT-ID>.supabase.co' || supabaseAnonKey === '<ANON_KEY>') {
  throw new Error('Missing Supabase variables');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true
  }
})

console.log('Supabase: Connected to', supabaseUrl)